import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/browser';

export const errorLink = onError(({ forward, networkError, operation }) => {
  if (networkError) {
    Sentry.captureException(networkError);
  }

  forward(operation);
});
